import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledCharacterCountContainer = styled(Ds.Flex)`
    margin-left: auto;
`;
